/**
 * SC Product Options: calculate and display Total Price (base variant price + Total Extras).
 * Total Price row is added in buy-box.liquid; this script fills the value.
 */
(function () {
	function parseMoneyToCents(text) {
		if (!text || typeof text !== "string") return 0;
		// Strip currency symbols and spaces; keep digits, dot, comma
		let cleaned = text.replace(/[^\d.,]/g, "");
		// Comma as thousand separator (e.g. $1,000.00): remove commas. Comma as decimal (e.g. 399,00): treat as decimal point.
		if (cleaned.indexOf(".") !== -1) {
			cleaned = cleaned.replace(/,/g, "");
		} else {
			cleaned = cleaned.replace(",", ".");
		}
		const num = parseFloat(cleaned);
		return isNaN(num) ? 0 : Math.round(num * 100);
	}

	function formatMoney(cents) {
		// Prefer BOLD/theme formatters so format matches Total Extras
		if (window.BOLD && window.BOLD.common && window.BOLD.common.Shopify && typeof window.BOLD.common.Shopify.formatMoney === "function") {
			return window.BOLD.common.Shopify.formatMoney(cents);
		}
		if (typeof window.formatMoney === "function") {
			return window.formatMoney(cents);
		}
		if (window.theme && window.theme.moneyFormat) {
			const format = window.theme.moneyFormat;
			const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
			const formatType = match ? match[1] : "amount";
			let value = (cents / 100).toFixed(2);
			if (formatType === "amount_with_comma_separator") {
				value = value.replace(".", ",");
			}
			return format.replace(/\{\{\s*\w+\s*\}\}/, value);
		}
		return (cents / 100).toFixed(2);
	}

	function getTotalExtrasCents(container) {
		if (!container) return 0;
		// Only parse the value that sits next to "Total Extras" / "Total Extras:" so we don't add
		// other prices (e.g. option row "+$5.00" or stray digits from "4th Gen")
		const optionTotalEl = container.querySelector(".bold_option_total");
		if (!optionTotalEl) return 0;
		const divs = optionTotalEl.querySelectorAll(":scope > div");
		for (let d = 0; d < divs.length; d++) {
			const raw = (divs[d].textContent || "").trim();
			if (raw.indexOf("Total Extras") === -1) continue;
			const spans = divs[d].querySelectorAll("span");
			for (let i = 0; i < spans.length; i++) {
				const t = (spans[i].textContent || "").trim();
				if (/^\$?[\d,]+\.\d{2}$/.test(t)) return parseMoneyToCents(t);
			}
			const priceMatch = raw.match(/\$[\d,]+\.\d{2}/);
			if (priceMatch) return parseMoneyToCents(priceMatch[0]);
			return 0;
		}
		return 0;
	}

	function getBasePriceCents(form, sectionId, variantsById) {
		const idInput = form && form.querySelector('input[name="id"]');
		const variantId = idInput ? idInput.value : null;
		if (variantId && variantsById) {
			const price = variantsById[variantId] ?? variantsById[Number(variantId)];
			if (price != null) return Number(price);
		}
		// By section id
		if (sectionId) {
			const byId = document.getElementById("price-" + sectionId);
			if (byId && byId.dataset.variantPrice) return Number(byId.dataset.variantPrice) || 0;
		}
		// Fallback: price wrapper in same buy-box as this form
		const buyBox = form.closest && form.closest(".buy-box");
		if (buyBox) {
			const wrapper = buyBox.querySelector(".bold_option_price_wrapper[data-variant-price], .price-wrapper[data-variant-price], [data-variant-price]");
			if (wrapper && wrapper.dataset.variantPrice) return Number(wrapper.dataset.variantPrice) || 0;
			// Last resort: parse visible price from .price-item (main product price)
			const priceEl = buyBox.querySelector(".price-item--regular, .price-item--sale, .price-item");
			if (priceEl && priceEl.textContent) return parseMoneyToCents(priceEl.textContent);
		}
		return 0;
	}

	var updating = false;
	function updateTotalPrice(form, sectionId, variantsById, observer) {
		if (updating) return;
		const optionsContainer = form && form.querySelector(".bold_options");
		if (!optionsContainer) return;

		updating = true;
		if (observer) observer.disconnect();
		try {
			doUpdateTotalPrice(form, sectionId, variantsById, optionsContainer);
		} finally {
			updating = false;
			if (observer) observer.observe(optionsContainer, { childList: true, subtree: true });
		}
	}
	function doUpdateTotalPrice(form, sectionId, variantsById, optionsContainer) {
		// 1) Only show Total Price for items that have options (app has injected into .bold_options)
		var hasOptions = optionsContainer.children.length > 0;
		if (!hasOptions) {
			var rowEl = form.querySelector(".bold_options_total_price_row") || document.getElementById("sc-options-total-price-row-" + sectionId);
			if (rowEl) rowEl.style.display = "none";
			return;
		}

		// 2) Total Price = 原本個 price + Total Extras (extras can be 0 when nothing selected)
		var baseCents = getBasePriceCents(form, sectionId, variantsById);
		var extrasCents = getTotalExtrasCents(optionsContainer);
		var totalCents = baseCents + extrasCents;
		var formattedTotal = formatMoney(totalCents);

		// 3) Fill theme row (buy-box.liquid)
		var rowEl = form.querySelector(".bold_options_total_price_row");
		var valueEl = form.querySelector(".bold_options_total_price_value");
		if (!rowEl || !valueEl) {
			rowEl = document.getElementById("sc-options-total-price-row-" + sectionId);
			valueEl = document.getElementById("sc-options-total-price-value-" + sectionId);
		}
		if (!rowEl || !valueEl) {
			var next = optionsContainer.nextElementSibling;
			if (next && next.classList.contains("bold_options_total_price_row")) {
				rowEl = next;
				valueEl = next.querySelector(".bold_options_total_price_value");
			}
		}
		if (rowEl && valueEl) {
			valueEl.textContent = formattedTotal;
			rowEl.style.display = "";
		}

		// 4) Hide only "Total Price:" inside the same row as "Total Extras" (one div has both)
		var optionTotalEl = optionsContainer.querySelector(".bold_option_total");
		if (optionTotalEl) {
			var divs = optionTotalEl.querySelectorAll(":scope > div");
			for (var d = 0; d < divs.length; d++) {
				var div = divs[d];
				if ((div.textContent || "").indexOf("Total Price") === -1) continue;
				if (div.querySelector(".sc-hide-app-total-price")) continue;
				hideTotalPriceLabelInNode(div);
				break;
			}
		}
	}

	function hideTotalPriceLabelInNode(container) {
		var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
		var textNode;
		while ((textNode = walker.nextNode())) {
			var text = textNode.textContent || "";
			var i = text.indexOf("Total Price");
			if (i === -1) continue;
			var before = text.substring(0, i);
			var toHide = text.substring(i);
			var parent = textNode.parentNode;
			if (before.length > 0) {
				parent.insertBefore(document.createTextNode(before), textNode);
			}
			var span = document.createElement("span");
			span.className = "sc-hide-app-total-price";
			span.textContent = toHide;
			parent.insertBefore(span, textNode);
			parent.removeChild(textNode);
			return;
		}
	}

	function getVariantsById(sectionId) {
		const scriptEl = document.getElementById("ProductVariantsPrice-" + sectionId);
		if (!scriptEl || !scriptEl.textContent) return null;
		try {
			const arr = JSON.parse(scriptEl.textContent.trim());
			const map = {};
			arr.forEach(function (v) {
				map[v.id] = v.price;
				map[String(v.id)] = v.price;
			});
			return map;
		} catch (e) {
			return null;
		}
	}

	function initForm(form) {
		const formId = String(form.id || "");
		const sectionId = formId.replace("product-form-", "").trim() || "";
		// Get variants: by section id, or from first ProductVariantsPrice script on page
		let variantsById = sectionId ? getVariantsById(sectionId) : null;
		if (!variantsById) {
			const scripts = document.querySelectorAll('script[id^="ProductVariantsPrice-"]');
			for (let i = 0; i < scripts.length; i++) {
				const id = scripts[i].id.replace("ProductVariantsPrice-", "");
				variantsById = getVariantsById(id);
				if (variantsById) break;
			}
		}

		var observer = null;
		function run() {
			updateTotalPrice(form, sectionId, variantsById, observer);
		}

		run();

		var debounceTimer = null;
		function debouncedRun() {
			if (debounceTimer) clearTimeout(debounceTimer);
			debounceTimer = setTimeout(function () {
				debounceTimer = null;
				run();
			}, 120);
		}

		const optionsContainer = form.querySelector(".bold_options");
		if (optionsContainer) {
			observer = new MutationObserver(function () {
				debouncedRun();
			});
			// Only observe structure (no characterData) so our own textContent updates don't retrigger and cause hang
			observer.observe(optionsContainer, { childList: true, subtree: true });
		}
		setTimeout(run, 800);

		const idInput = form.querySelector('input[name="id"]');
		if (idInput) {
			idInput.addEventListener("change", run);
		}
	}

	function init() {
		// 1) Forms marked for Total Price (buy-box with options) – ensure script is used
		const marked = document.querySelectorAll('form[data-sc-total-price="true"]');
		marked.forEach(function (form) {
			if (form.querySelector(".bold_options")) initForm(form);
		});
		// 2) Fallback: any add-to-cart form with .bold_options
		const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
		forms.forEach(function (form) {
			if (form.hasAttribute("data-sc-total-price")) return;
			const optionsContainer = form.querySelector(".bold_options");
			if (optionsContainer) initForm(form);
		});
		// 3) Cart edit modal: when modal opens with .bold_option_total, hide "Total Price:" label (same as product page)
		hideTotalPriceInModals();
		var modalObserver = new MutationObserver(function (mutations) {
			for (var m = 0; m < mutations.length; m++) {
				var added = mutations[m].addedNodes;
				for (var i = 0; i < added.length; i++) {
					var node = added[i];
					if (node.nodeType !== 1) continue;
					var optionTotals = [];
					if (node.matches && node.matches(".bold_option_total")) optionTotals = [node];
					else if (node.querySelectorAll) optionTotals = Array.prototype.slice.call(node.querySelectorAll(".bold_option_total"));
					for (var t = 0; t < optionTotals.length; t++) {
						var el = optionTotals[t];
						if (el.closest && el.closest(".buy-box")) continue;
						if (el.querySelector(".sc-hide-app-total-price")) continue;
						hideTotalPriceLabelInNode(el);
					}
				}
			}
		});
		modalObserver.observe(document.body, { childList: true, subtree: true });
	}

	function hideTotalPriceInModals() {
		var optionTotals = document.querySelectorAll(".bold_option_total");
		for (var i = 0; i < optionTotals.length; i++) {
			var el = optionTotals[i];
			if (el.closest && el.closest(".buy-box")) continue;
			if (el.querySelector(".sc-hide-app-total-price")) continue;
			hideTotalPriceLabelInNode(el);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
